<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h480_dialog abow_dialog"
      width="1280px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                    prop="provinceId"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                    prop="cityId"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="区县"
                    prop="countyId"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.countyName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="姓名"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.name"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="电话"
                    prop="phone"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.phone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="性别">
                    <el-input
                      v-model="dialogAddEditViewForm.sexStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="地址">
                    <el-input
                      v-model="dialogAddEditViewForm.realAddress"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              关联零售户信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-table
                    :data="relationListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                    />
                    <el-table-column
                      prop="certificateNo"
                      label="专卖证号"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.certificateNo"
                          disabled
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="storeName"
                      label="店名"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.storeName"
                          disabled
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="benxiangStoreNo"
                      label="本香门店码"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.benxiangStoreNo"
                          disabled
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="affirmCertificateNo"
                      label="认证专卖证号"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.affirmCertificateNo"
                          disabled
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="affirmStoreName"
                      label="认证店名"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.affirmStoreName"
                          disabled
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="affirmBenxiangStoreNo"
                      label="认证本香门店码"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.affirmBenxiangStoreNo"
                          disabled
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="110"
                    >
                      <template slot-scope="scope">
                        <el-button
                          v-if="scope.row.storeId === null || scope.row.storeId === undefined || scope.row.storeId === '' || scope.row.storeId === 0 || scope.row.storeId === '0'"
                          type="danger"
                          size="mini"
                          @click="handleSureItem(scope.$index, scope.row)"
                        >
                          关联认证
                        </el-button>
                        <el-button
                          v-else
                          type="danger"
                          size="mini"
                          @click="clearStoreFun(scope.$index)"
                        >
                          清空
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 零售户列表 -->
    <store-list-dialog
      :city-id="String(dialogAddEditViewForm.cityId)"
      :certificate-no="certificateNo"
      :dialog-visible.sync="dialogStoreVisible"
      dialog-title="零售户信息"
      @selectedStoreFun="selectedStoreFun"
    />
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 选择零售户
import storeListDialog from './storeListDialog'
import { initAppUserApi, saveOrUpdateAppUserApi } from '@/api/appUser'
export default {
  components: { storeListDialog },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {

      },
      relationListData: [],
      dialogStoreVisible: false,
      currentIndex: 0,
      certificateNo: ''
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          provinceName: '',
          provinceId: '',
          cityName: '',
          cityId: '',
          countyName: '',
          countyId: '',
          name: '',
          phone: '',
          sexStr: '',
          realAddress: '',
          type: 1,
          remark: ''
        }
        this.relationListData = []
        this.dialogStoreVisible = false
        this.currentIndex = 0
        this.certificateNo = ''
        this.initUserData()
      }
    }
  },
  methods: {
    // 加载数据
    initUserData() {
      initAppUserApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.relationListData = data.relationList
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    handleSureItem(index, item) {
      this.currentIndex = index
      this.certificateNo = item.certificateNo
      this.dialogStoreVisible = true
    },
    selectedStoreFun(val) {
      this.relationListData[this.currentIndex].storeId = val.id
      this.relationListData[this.currentIndex].affirmCertificateNo = val.certificateNo
      this.relationListData[this.currentIndex].affirmStoreName = val.storeName
      this.relationListData[this.currentIndex].affirmBenxiangStoreNo = val.benxiangStoreNo
    },
    clearStoreFun(index) {
      this.relationListData[index].storeId = ''
      this.relationListData[index].affirmCertificateNo = ''
      this.relationListData[index].affirmStoreName = ''
      this.relationListData[index].affirmBenxiangStoreNo = ''
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      let storeData = []
      this.relationListData.forEach(item => {
        if (item.storeId !== null && item.storeId !== undefined && item.storeId !== '' && item.storeId !== 0 && item.storeId !== '0') {
          storeData.push({ id: item.id, storeId: item.storeId })
        }
      })
      if (storeData.length === 0) {
        this.$message({
          message: '请选择门店关联',
          type: 'warning'
        })
        return false
      }
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否确定关联零售户', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.dialogAddEditViewForm.storeData = JSON.stringify(storeData)
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave() {
      let params = {
        isLink: 1,
        id: this.dialogAddEditViewForm.id,
        storeData: this.dialogAddEditViewForm.storeData
      }
      saveOrUpdateAppUserApi(params).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
</style>
